/**
 * Invoice synchronization operation DTO - matches the backend API contract.
 */
export enum InvoiceSyncOperationDTO {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
}

export type InvoiceSyncOperationResponse = InvoiceSyncOperationDTO;
